<template>
    <div class="app-card-list">
      <div class="card" v-for="(item, index) in cardList" :key="index" @click="goTo(item)">
        <slot :name="index.toString()"></slot>
        <p>{{ item.title }}</p>
      </div>
    </div>
</template>

<script>
import { commonMixin } from 'common/js/mixin';

  export default {
    mixins: [commonMixin],
    name: 'app-card-list',
    props: {
      cardList: {
        type: Array,
        default: () => []
      },
    },
    methods: {
      goTo(item) {
        if(item.route === 'urgent' && item.value === 0) {
          this.showToast('暂无急需续费的门店或设备', 'warn');
          return false;
        }
        this.$router.push({name: item.route});
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "common/sass/common.scss";

  .app-card-list {
    display: flex;
    flex-flow: row;
    // height: 120px;
    // line-height: 120px;
    background-color: $primary-color;
    font-size: 14px;
    .card {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-flow: column;
      line-height: 25px;
      flex: 1;
      &:hover {
        background-color: $gray-color;
      }
      > p{
        margin-bottom: 10px;
      }
      img {
        width: 32px;
        height: 32px;
        font-size: 0;
      }
    }
  }
</style>
